import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';

@Component({
    selector: 'date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent {
    @Input() label: string;
    @Input() disabled: boolean = false;
    @Input() minDate: string;
    @Input() maxDate: string;
	@Input() ngIf?: boolean = true;
    @Input() placeholder: string = "Selecione a data...";
	@Input() model?: any = null;
    @Input() canClear?: boolean = false;
    @Output() onChange = new EventEmitter<any>();
	@Output() modelChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() noPadding: boolean = false;

    @ViewChild('d') datepicker: NgbInputDatepicker;

    public change(event) {
		this.modelChange.emit(event);
        this.onChange.emit(event);
    }

    public ngbDate(stringDate: string): NgbDateStruct | null {
        if (!stringDate) {
            return null;
        }
        const formatted =  new DateTime(stringDate).toFormat('yyyy/MM/dd');
        const date = new Date(formatted);
        return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    }

    public clear() {
        this.model = null;
        this.datepicker.close();
    }
}
